import React, { useEffect, useState } from 'react';
import Image from 'next/image';
import Link from 'next/link';
import { useTranslations } from 'next-intl';

type BannerType = {
  id: string;
  backgroundCircles: { className: string }[];
  buttonText: string;
  buttonColor: string;
  imageSrc: string;
  imageTop: string;
  url: string;
};

const banners = [
  {
    id: 'instagram',
    backgroundCircles: [
      {
        className:
          'absolute left-1/2 top-1/2 h-[1444px] w-[1407.4281px] -translate-x-1/2 -translate-y-1/2 rounded-full bg-[#4D0921]'
      },
      {
        className:
          'left-140 absolute top-1/2 h-[1000px] w-[1000px] -translate-x-1/2 -translate-y-1/2 rounded-full bg-[#661011]'
      },
      {
        className:
          'left-150 absolute top-1/2 h-[661px] w-[679px] -translate-x-1/2 -translate-y-1/2 rounded-full bg-[#500405]'
      },
      {
        className:
          'top-7 absolute left-60 h-[517px] w-[531px] -translate-x-1/2 -translate-y-1/2 rounded-full bg-[#400102]'
      },
      {
        className:
          'top-10 absolute left-60 h-[271.99999px] w-[485.1359px] -translate-x-1/2 -translate-y-1/2 rounded-full bg-[#C3414182] blur-2xl'
      }
    ],
    buttonText: 'instagramga_otish',
    buttonColor: 'text-red-600',
    imageSrc: '/images/instagram-banner.webp',
    imageTop: 'top-5',
    url: `${process.env.NEXT_PUBLIC_INSTAGRAM}`
  },
  {
    id: 'telegram',
    backgroundCircles: [
      {
        className:
          'absolute left-1/2 top-1/2 h-[1444px] w-[1407.4281px] -translate-x-1/2 -translate-y-1/2 rounded-full bg-[#02414E]'
      },
      {
        className:
          'left-140 absolute top-1/2 h-[1000px] w-[1000px] -translate-x-1/2 -translate-y-1/2 rounded-full bg-[#013540]'
      },
      {
        className:
          'left-150 absolute top-1/2 h-[661px] w-[679px] -translate-x-1/2 -translate-y-1/2 rounded-full bg-[#044350]'
      },
      {
        className:
          'absolute left-60 top-7 h-[517px] w-[531px] -translate-x-1/2 -translate-y-1/2 rotate-45 rounded-full bg-[#013540]'
      },
      {
        className:
          'absolute left-60 top-10 h-[271.99999px] w-[485.1359px] -translate-x-1/2 -translate-y-1/2 rounded-full bg-[#0F6171] blur-2xl'
      }
    ],
    buttonText: 'telegramga_otish',
    buttonColor: 'text-sky-600',
    imageSrc: '/images/telegram-banner.webp',
    imageTop: 'top-10',
    url: `${process.env.NEXT_PUBLIC_TELEGRAM}`
  }
];

const SocialMediaBanner = () => {
  const t = useTranslations();
  const [selectedBanner, setSelectedBanner] = useState<BannerType | null>(null);

  useEffect(() => {
    const randomIndex = Math.floor(Math.random() * banners.length);

    setSelectedBanner(banners[randomIndex]);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (!selectedBanner) {
    return <div className="relative z-0 mb-5 h-60 w-full animate-pulse rounded-2xl bg-gray-200" />;
  }

  return (
    <div className="relative h-40 w-full overflow-hidden md:mb-5 md:h-60 md:rounded-2xl">
      {selectedBanner?.backgroundCircles.map((circle, index) => (
        // eslint-disable-next-line react/no-array-index-key
        <div key={index} className={circle.className} />
      ))}

      <div className="relative z-10 p-4 text-white md:p-8">
        <h1 className="w-full text-lg font-bold md:max-w-[38rem]  md:text-3xl">
          {t('bizni_ijtimoiy_tarmoqlarda_kuzatib_boring')?.toUpperCase()}
        </h1>
        <p className="text-light md:text-md mt-2 hidden w-full text-xs sm:block sm:max-w-md md:max-w-[30rem]">
          {t('bizni_ijtimoiy_tarmoqlarda_kuzatib_boring_desc')}
        </p>
        <Link
          target="_blank"
          href={selectedBanner?.url}
          className={`mt-5 inline-block rounded-xl bg-white px-3 py-2 font-semibold ${selectedBanner?.buttonColor} shadow hover:bg-white/80`}
        >
          {t(selectedBanner?.buttonText)}
        </Link>
      </div>

      <Image
        src={selectedBanner?.imageSrc}
        height={351}
        width={348}
        alt="social-banner"
        className={`lg:h-95 md:h-65 lg:w-95 md:w-65 top-15 sm:right-15 lg:right-30 absolute right-6 h-40 w-40 sm:top-12 lg:top-5 ${selectedBanner?.imageTop} z-10 object-cover md:rounded-xl`}
      />
    </div>
  );
};

export default SocialMediaBanner;
